import { render, staticRenderFns } from "./MortgageApplicationsObjects.vue?vue&type=template&id=48f6b5c5&scoped=true&"
import script from "./MortgageApplicationsObjects.vue?vue&type=script&lang=js&"
export * from "./MortgageApplicationsObjects.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../bankari hypo/BankariBroker/frontend/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48f6b5c5",
  null
  
)

export default component.exports